export default __webpack_public_path__ + "static/media/way-to-go.117db02d.webp";